var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.AuthenticationMixin_LoggedIn && _vm.AuthenticationMixin_HasRights(['admin']))?_c('v-card',{staticClass:"ma-3"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }